export default {
    path: '/readfilder',
    name: 'readfilder',
    component: () => import(/* webpackChunkName: "login" */ "@/pages/readfilder/index"),
    meta: {
            title: '读取文件'
    }
}
